<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11ztLij/tc-custom/9780292786165.jpg?1728725961669" alt="This image is the cover for the book Confederate Cavalry West of the River"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confederate Cavalry West of the River
      </h1>
      <p class="bookDescription body article font2">
        <p> Another Confederate cavalry raid impends. You hear the snort of an impatient horse, the leathery squeaking of saddles, the low-voiced commands of officers, the muffled cluck of guns cocked in preparation—then the sudden rush of motion, the din of another attack. </p><p> This classic story seeks to illuminate a little-known theater of the Civil War—the cavalry battles of the Trans-Mississippi West, a region that included Missouri, Arkansas, Texas, the Indian Territory, and part of Louisiana. Stephen B. Oates traces the successes and defeats of the cavalry; its brief reinvigoration under John S. "Rip" Ford, who fought and won the last battle of the war at Palmetto Ranch; and finally, the disintegration of this once-proud fighting force. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen B. Oates
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7eefff81